"use strict";

// Re-initialize CF7 on popup show.
window.addEventListener( 'elementor/popup/show', () => {
	const forms = document.querySelectorAll( '.elementor-popup-modal form.wpcf7-form:not(.elementor)' );

	forms.forEach( ( form ) => {
		wpcf7.init( form );
		form.classList.add( 'elementor' ); // Add class to avoid running again.
	} );
} );

// Group all lightbox images on page together.
window.addEventListener( 'DOMContentLoaded', () => {
	const selectors = [
		'.elementor-widget-image a[data-elementor-open-lightbox="yes"]',
		'.elementor-widget-image-carousel a[data-elementor-open-lightbox="yes"]'
	];

	const $lightboxImagesLinks = document.querySelectorAll( selectors.join( ', ' ) );

	for ( const $link of $lightboxImagesLinks ) {
		$link.setAttribute( 'data-elementor-lightbox-slideshow', 'all' );
	}
} );
